import { Anchoring } from './Anchoring';
export default class AnchoringOutOfTheWaterData extends Anchoring {
    constructor(anchor, freeText) {
        super(anchor, freeText);
    }
}
//# sourceMappingURL=AnchoringOutOfTheWaterData.js.map